import React, { Component } from "react";
import { SyncLoader, ClockLoader } from "react-spinners";
import { colors } from "../data/Colors";
import classNames from "classnames";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "./noti.scss";
export default class LoadingAnimation extends Component {
  render() {
    const style = {
      position: "absolute",
      display: "block",
      justifyContent: "center",
      textAlign: "center",
      top: "40vh",
      bottom: 0,
      left: 0,
      right: 0,
    };

    return (
      <div style={this.props.style || style}>
        {this.props.text ? (
          <ClockLoader
            css={{ display: "block", margin: "auto" }}
            sizeUnit={"px"}
            size={40}
            color={colors["base-success"]}
          />
        ) : (
          <SyncLoader
            css={{ display: "block" }}
            sizeUnit={"px"}
            size={15}
            color={colors["base-success"]}
          />
        )}
        <div className="px-5 font-weight-bold mt-3 text-center">
          {this.props.text}
        </div>
      </div>
    );
  }
}

export const SkeletonLoadingAnimation = ({
  height,
  className,
  width,
  count,
  noPadding,
  containerClassNames,
}) => {
  let containerClasses = classNames(`${containerClassNames}`);
  let classes = classNames(`skeleton-loading-animation ${className}`);
  return (
    <div className={`${noPadding ? "pb-2" : "px-2 pb-2"}`}>
      <SkeletonTheme baseColor="#F6F6F6" highlightColor="#E6E6E6">
        <Skeleton
          containerClassName={containerClasses}
          className={classes}
          height={height}
          width={width}
          count={count}
        />
      </SkeletonTheme>
    </div>
  );
};

export const MessageLoadingAnimation = () => {
  return (
    <div className="fade-loader-16">
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={i} className="fade-bar" style={{ "--i": i }}></div>
      ))}
    </div>
  );
};
export const InfiniteLoadingProgressBar = ({ showHeader = false }) => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center h-100">
      <LoadingAnimation />
    </div>
  );
};

export const RelativeLoadingAnimation = ({
  marginTop = "200px",
  showInfiniteLoader = false,
}) => {
  return (
    <div className="relative-loading-animation d-flex justify-content-center">
      <div style={showInfiniteLoader ? {} : { marginTop }}>
        {showInfiniteLoader ? (
          <InfiniteLoadingProgressBar showHeader={false} />
        ) : (
          <SyncLoader size={15} color={colors["base-success"]} />
        )}
      </div>

      {/* <div className="px-5 font-weight-bold mt-3 text-center">{this.props.text}</div> */}
    </div>
  );
};

export const ButtonLoadingAnimation = () => {
  return (
    <div className="me-2">
      <SyncLoader size={10} color={"#FFF"} />
      {/* <div className="px-5 font-weight-bold mt-3 text-center">{this.props.text}</div> */}
    </div>
  );
};
